/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DataClass } from '../models/DataClass';
import { ListOperators } from '../models/ListOperators';

export class DataClassesCondition {
  'operator': ListOperators;
  'dataClasses': Array<DataClass>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "operator",
      "baseName": "operator",
      "type": "ListOperators",
      "format": ""
    },
    {
      "name": "dataClasses",
      "baseName": "dataClasses",
      "type": "Array<DataClass>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DataClassesCondition.attributeTypeMap;
  }

  public constructor() {
  }
}



